import { Controller } from "@hotwired/stimulus";
import { HSTooltip } from "preline/dist/preline.js";

// Connects to data-controller="truncate" on a `.hs-tooltip.--prevent-on-load-init` cell:
// the Preline tooltip is only activated when the cell content is actually cut off
export default class extends Controller {
  static targets = ["tooltip"];

  connect() {
    this.tooltipTarget.textContent = this.cellText();
    this.refresh();
    document.fonts?.ready.then(() => this.element.isConnected && this.refresh());
  }

  disconnect() {
    this.tooltip?.destroy();
    this.tooltip = null;
  }

  refresh() {
    const truncated = this.element.scrollWidth > this.element.clientWidth;

    if (truncated && !this.tooltip) {
      this.tooltip = new HSTooltip(this.element);
    } else if (!truncated && this.tooltip) {
      this.tooltip.destroy();
      this.tooltip = null;
    }
  }

  cellText() {
    return Array.from(this.element.childNodes)
      .filter((node) => node !== this.tooltipTarget)
      .map((node) => node.textContent)
      .join("")
      .trim()
      .replace(/\s+/g, " ");
  }
}
